export function isEditMode(): boolean {
  return window.location.pathname.endsWith('/edit')
}
